import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useEffect } from "react";
import { getNotificationApi, markReadNotificationApi } from "./Notification.api";
import { useAuth } from "context/auth-context";
import logo from "../../../assets/notificationLogo.png";
import { formatDistanceToNow } from "date-fns";
import { useTranslation } from "react-i18next";

const PointUIModel = ({ activeTab }: any) => {
  const { auth } = useAuth();
  const { t } = useTranslation();
  const type = "point";
  const queryClient = useQueryClient();

  // Fetch notifications with proper dependency on activeTab
  const { data } = useQuery(
    ["notification", auth.panelistId, type],
    () => getNotificationApi(auth.panelistId, type),
    {
      refetchOnWindowFocus: false,
    }
  );
  // Mark notifications as read
  const markAsReadMutation = useMutation(
    (notificationIds: number[]) => markReadNotificationApi(auth.panelistId, notificationIds, type),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["notification", auth.panelistId, type]);
      },
    }
  );

  useEffect(() => {
    return () => {
      // Only execute when leaving the "Survey" tab
      if (data?.NotificationData) {
        const unreadNotifications = data.NotificationData.filter(
          (notification: any) => !notification.mark_as_read
        );
        if (unreadNotifications.length > 0) {
          const unreadIds = unreadNotifications.map((notification: any) => notification.id);
          markAsReadMutation.mutate(unreadIds);
        }
      }
    };
  }, [activeTab, data?.NotificationData]);

  return (
    <div>
      <div className="space-y-4">
        {data?.NotificationData?.length > 0 ? (
          data?.NotificationData?.map((notification: any) => (
            <div
              key={notification.id}
              className={`p-4 rounded-md flex items-start gap-4 ${
                notification.mark_as_read === 0 ? "" : ""
              }`}
            >
              {/* Avatar */}
              <img src={logo} alt="avatar" className="w-[45px] h-[45px] rounded-full" />
              {/* Notification Details */}
              <div className="flex-1">
                <div
                  className={`text-base ${
                    notification.mark_as_read === 0
                      ? " text-base text-[#000000]"
                      : "text-[#585858] text-sm"
                  }`}
                >
                  {notification.message}
                </div>
                <div
                  className={`${
                    notification.mark_as_read === 0 ? "text-[#000000]" : "text-[#585858]"
                  } text-xs flex justify-between mt-2`}
                >
                  <span>
                    {new Intl.DateTimeFormat("en-US", {
                      weekday: "long",
                      day: "numeric",
                      month: "short",
                      year: "numeric",
                    }).format(new Date(notification.created_at))}
                  </span>
                  <span>
                    {formatDistanceToNow(new Date(notification.created_at), { addSuffix: true })
                      .replace("about ", "")
                      .replace("less than ", "")}
                  </span>
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="text-black text-center">{t("point.notification.available")}</div>
        )}
      </div>
    </div>
  );
};

export default PointUIModel;
